import * as moment from 'moment-timezone';
import { DateHelpers } from '../helpers/DateHelpers';
import { Module } from '../Module';
import { GetNextPasswordValidationAttemptDate, GetNextPasswordValidationAttemptDateResult } from '../ServerApi/requests/GetNextPasswordValidationAttemptDate';
import { NotifyingFutureActionService } from './NotifyingFutureActionService';
import { ServerService } from './ServerService';

export class UserLockoutMessageService {

  private static DEFAULT_REFRESH_RATE = 1000; // 1 second

  public static $inject = [
    'NotifyingFutureActionService',
    'ServerService',
  ];

  constructor(
    private notifyingFutureActionService: NotifyingFutureActionService,
    private serverService: ServerService,
    ) {}

  public showMessageForUser(username: string, showMessage: (message: string) => void, callback: () => void): void {
      this.serverService.sendRequest(new GetNextPasswordValidationAttemptDate(username)).then(
          (result: GetNextPasswordValidationAttemptDateResult) => {
        this.notifyingFutureActionService.register({
            messageKey: 'passwordLockoutPeriod',
            targetDate: moment(<any>result).toDate(),
            dateArrivedListener: callback,
            showNewMessage: showMessage,
        });
      });
  }
}

Module.instance().service('UserLockoutMessageService', UserLockoutMessageService);
